const MAX_ACCOUNT_AGE_MS = 30 * 24 * 60 * 60 * 1000;
const pending = new Map();

// A completed first reply should check off the tour immediately. Read the
// server's counters instead of guessing usage from optimistic chat messages.
export function refreshNewUserChecklist(auth) {
  const user = auth?.user;
  const age = Date.now() - new Date(user?.createdAt).getTime();
  if (!user?.id || user.flags?.isGhost || !(age >= 0 && age <= MAX_ACCOUNT_AGE_MS)
      || user.stats?.total_sent_message_all_count > 0 || !auth.fetchUserSlim) {
    return Promise.resolve();
  }
  const key = `${user.id}:${auth._sessionGeneration}`;
  if (pending.has(key)) return pending.get(key);
  // fetchUserSlim already rejects results from a previous account/session.
  const promise = Promise.resolve().then(() => auth.fetchUserSlim())
    .catch(() => {})
    .finally(() => pending.delete(key));
  pending.set(key, promise);
  return promise;
}
